export interface RuntimeConfig {
  apiUrl: string;
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  environment?: string;
}

let config: RuntimeConfig | null = null;

function assertValid(raw: unknown): asserts raw is RuntimeConfig {
  if (typeof raw !== 'object' || raw === null) {
    throw new Error('runtimeConfiguration.json did not contain a JSON object');
  }
  const required: Array<keyof RuntimeConfig> = [
    'apiUrl',
    'keycloakUrl',
    'keycloakRealm',
    'keycloakClientId',
  ];
  const missing = required.filter(
    (key) => typeof (raw as Record<string, unknown>)[key] !== 'string',
  );
  if (missing.length > 0) {
    throw new Error(
      `runtimeConfiguration.json is missing required string keys: ${missing.join(', ')}`,
    );
  }
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (config) return config;

  const response = await fetch('/runtimeConfiguration.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(
      `Failed to load /runtimeConfiguration.json: HTTP ${response.status} ${response.statusText}`,
    );
  }

  let parsed: unknown;
  try {
    parsed = await response.json();
  } catch (cause) {
    throw new Error('Failed to parse /runtimeConfiguration.json as JSON', { cause });
  }

  assertValid(parsed);
  config = parsed;
  return config;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!config) {
    throw new Error(
      'getRuntimeConfig() called before loadRuntimeConfig() completed. ' +
        'The config must be awaited in main.tsx before rendering.',
    );
  }
  return config;
}
